import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: FaqState = {
    all: [],
};

const rootState: FaqState = initialState;

const getters: GetterTree<FaqState, RootState> = {
    all(state: FaqState): Faq[] | undefined {
        return state.all;
    },
};

const mutations: MutationTree<FaqState> = {
    RESET(state: FaqState) {
        state.all = [];
    },
    SET_FAQ(state: FaqState, payload: Faq[]) {
        state.all = payload;
    },
    ADD_FAQ(state: FaqState, payload: Faq) {
        if (state.all) {
            state.all.push(payload);
        }
    },
};

const actions: ActionTree<FaqState, RootState> = {

    read({ commit }, payload: FaqIndexPayload): any {

        // @ts-ignore
        return this._vm.$mockApi.get(`faq.json`, { withCredentials: true })
            .then((response: { data: Faq[] }) => {
                let faqs: Faq[] = response.data;
                if (payload && payload.ids) {
                    faqs = faqs.filter((faq: Faq) => payload.ids?.includes(faq.id));
                }
                if (payload && payload.emotion) {
                    // @ts-ignore
                    faqs = faqs.filter((faq: Faq) => faq.emotions?.includes(payload.emotion));
                }
                if (payload && payload.level) {
                    // @ts-ignore
                    faqs = faqs.filter((faq: Faq) => faq.levels.includes(payload.level));
                }

                commit('SET_FAQ', faqs);

                return Promise.resolve(faqs);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
};

export default {
    namespaced: true,
    state: rootState,
    getters,
    actions,
    mutations,
};
